export const POSITION_LIST_HEADER_COLUMNS = [
  {
    key: 'symbol',
    title: 'Market',
    customClass: ['market-column'],
    defaultSortingOrder: 'ascending'
  },
  {
    key: 'position_qty',
    title: 'Size',
    defaultSortingOrder: 'descending'
  },
  {
    key: 'average_open_price',
    title: 'Avg. filled price',
    defaultSortingOrder: 'descending'
  },
  {
    key: 'mark_price',
    title: 'Mark price',
    defaultSortingOrder: 'descending'
  },
  {
    key: 'liquidationPrice',
    title: 'Liq. price',
    defaultSortingOrder: 'descending'
  },
  {
    key: 'unrealPnl',
    title: 'Unrealize P&L',
    defaultSortingOrder: 'descending'
  },
  {
    key: 'closePosition',
    title: '',
    isSortable: false
  }
]
